import * as React from 'react';
import Svg, {Path} from 'react-native-svg';
import Styles from 'src/components/Styles';
import Settings from 'src/Settings';

interface ICashRewardsIconProps {
  color?: string;
}

const backgroundColor = (colorValue: string) => {
  if (Settings.isAramark()) {
    return {color: Styles.Colors.PayNew.neutralHuesBase12, opacity: 1};
  }
  return {
    color: colorValue ?? Styles.Colors.PayNew.primary01,
    opacity: 0.14902,
  };
};

const CashRewardsIcon = (props: ICashRewardsIconProps) => (
  <Svg width="70" height="67" viewBox="0 0 70 67" {...props}>
    <Path
      d="M0 33.5C0 15 14.91 0 33.305 0h3.39C55.09 0 70 15 70 33.5S55.09 67 36.695 67h-3.39C14.91 67 0 52 0 33.5zm0 0"
      stroke="none"
      fillRule="nonzero"
      fill={backgroundColor(props.color).color}
      fillOpacity={backgroundColor(props.color).opacity}
    />
    <Path
      d="M46.617 24.586h-1.66v-1.668a5.024 5.024 0 00-1.457-3.543 4.967 4.967 0 00-3.52-1.465H23.383c-1.32 0-2.586.527-3.52 1.465a5.027 5.027 0 00-1.46 3.543v20.031c0 1.328.527 2.602 1.46 3.54a4.954 4.954 0 003.52 1.468h23.234c1.32 0 2.59-.527 3.524-1.469a5.014 5.014 0 001.457-3.539V29.594a5.03 5.03 0 00-1.457-3.543 4.976 4.976 0 00-3.524-1.465zm-23.234-3.34H39.98c.442 0 .864.176 1.172.488.313.317.489.739.489 1.184v1.668H23.383a1.67 1.67 0 01-1.172-2.852c.309-.312.73-.488 1.172-.488zm24.894 16.695h-1.66a1.66 1.66 0 01-1.172-.488 1.67 1.67 0 011.172-2.852h1.66zm0-6.68h-1.66c-1.32 0-2.586.528-3.52 1.47a5.03 5.03 0 000 7.082 4.967 4.967 0 003.52 1.464h1.66v1.672a1.662 1.662 0 01-1.66 1.668H23.383a1.67 1.67 0 01-1.66-1.668V27.641a5.011 5.011 0 001.66.285h23.234a1.662 1.662 0 011.66 1.668zm0 0"
      stroke="none"
      fillRule="nonzero"
      fill={props.color ?? '#006dff'}
      fillOpacity={1}
    />
  </Svg>
);
export default CashRewardsIcon;
